var mobileScreenWidth = 992;
var maxchar = 60;

$(document).ready(function($) {

	if (screen.width < mobileScreenWidth) {
		$('.news .news__item--large').removeClass('col-xs-6 col-md-6').addClass('col-xs-12 col-md-12');
		$('.news .news__item--large-group').removeClass('col-xs-6 col-md-6').addClass('col-xs-12 col-md-12');

		document.querySelectorAll('.news__item--large-group .news__item--small').forEach(function(entry){
			var title = entry.querySelector('.news__feed__post__meta h5');

			//Truncates title text up to maxchar
			title.innerText = title.innerText.substring(0,maxchar-1)+(title.innerText.length>maxchar?'\u2026':'');
		});

	}

});
